var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppBgBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.153,
    cy: 137.808,
    r: 137.011,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0148 186.545L60.1302 186.352L63.0549 181.256C55.2121 168.076 51.0174 152.976 51.0174 137.21C51.0174 114.234 59.907 92.6365 76.0545 76.3901C92.2021 60.1437 113.668 51.1996 136.504 51.1996C159.34 51.1996 180.806 60.1437 196.953 76.3901C213.101 92.6365 221.99 114.234 221.99 137.21C221.99 152.968 217.788 168.076 209.953 181.256L212.877 186.352L213.709 187.807L227.016 211C243.264 190.851 253 165.18 253 137.217C252.992 72.4795 200.832 20 136.496 20C72.16 20 20 72.4795 20 137.21C20 165.172 29.7362 190.851 45.9838 210.992L60.0148 186.545Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 68.315,
    y1: 292.778,
    x2: 203.664,
    y2: -9.8448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02083D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545CA4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBgBlue);
export default __webpack_public_path__ + "static/media/app-bg-blue.08fcb4a03b868dcf1785afef919cb818.svg";
export { ForwardRef as ReactComponent };